import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const opts = {
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#0d47a1',
        secondary: '#C4812F'
      }
    }
  }
}

export default new Vuetify(opts)
